import { i18n } from '@fs/zion-locale'

export function getLocaleName(nameObj = {}, nativeLocale = 'en') {
  const i18nLanguageName = nameObj?.[i18n.language]
  const englishName = nameObj?.en
  const nativeLanguage = nameObj?.[nativeLocale]
  const firstName = Object.values(nameObj)?.[0]
  return i18nLanguageName || nativeLanguage || englishName || firstName || 'Not Found'
}

export function propertySort(property, ascending = true) {
  return (a, b) => {
    let result = 0
    if (typeof a[property] === 'string') {
      result = a[property].localeCompare(b[property])
    } else if (typeof a[property] === 'number') {
      result = a[property] - b[property]
    } else if (typeof a[property] === 'object') {
      const nativeLocaleA = a?.native_lang || 'en'
      const nativeLocaleB = b?.native_lang || 'en'
      result = getLocaleName(a[property], nativeLocaleA)?.localeCompare(getLocaleName(b[property], nativeLocaleB))
    }
    return ascending ? result : -1 * result
  }
}
